const Home = () => {
  window?.location.replace('/login');

  return null;
};

export default Home;
